/**
 * User Identification Form Component
 * Collects email, first name, and last name on first visit
 */
import React, { useState } from 'react';
import { translations } from '../translations';

const IdentificationForm = ({ onSubmit, language, isLoading, submitError }) => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [errors, setErrors] = useState({});

  const t = translations[language] || translations.en;

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!email.trim()) {
      newErrors.email = t.errors.emailRequired;
    } else if (!validateEmail(email)) {
      newErrors.email = t.errors.emailInvalid;
    }

    if (!firstName.trim()) {
      newErrors.firstName = t.errors.firstNameRequired;
    }

    if (!lastName.trim()) {
      newErrors.lastName = t.errors.lastNameRequired;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onSubmit({
      email: email.trim(),
      first_name: firstName.trim(),
      last_name: lastName.trim()
    });
  };

  return (
    <div className="afgcoin-chatbot-identification">
      {submitError && (
        <div className="afgcoin-chatbot-submit-error" role="alert">
          {submitError}
        </div>
      )}
      <form onSubmit={handleSubmit} className="afgcoin-chatbot-form" autoComplete="off">
        <div className="afgcoin-chatbot-form-group">
          <label htmlFor="email">{t.identification.email}</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t.identification.emailPlaceholder}
            disabled={isLoading}
            className={errors.email ? 'afgcoin-chatbot-input-error' : ''}
          />
          {errors.email && <span className="afgcoin-chatbot-error-message">{errors.email}</span>}
        </div>

        <div className="afgcoin-chatbot-form-group">
          <label htmlFor="firstName">{t.identification.firstName}</label>
          <input
            type="text"
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder={t.identification.firstNamePlaceholder}
            disabled={isLoading}
            className={errors.firstName ? 'afgcoin-chatbot-input-error' : ''}
          />
          {errors.firstName && <span className="afgcoin-chatbot-error-message">{errors.firstName}</span>}
        </div>

        <div className="afgcoin-chatbot-form-group">
          <label htmlFor="lastName">{t.identification.lastName}</label>
          <input
            type="text"
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder={t.identification.lastNamePlaceholder}
            disabled={isLoading}
            className={errors.lastName ? 'afgcoin-chatbot-input-error' : ''}
          />
          {errors.lastName && <span className="afgcoin-chatbot-error-message">{errors.lastName}</span>}
        </div>

        <button
          type="submit"
          className="afgcoin-chatbot-button-primary"
          disabled={isLoading}
        >
          {isLoading ? t.loading : t.identification.submit}
        </button>
      </form>
    </div>
  );
};

export default IdentificationForm;

